import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { of, Subscription } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { MatFormField, MatInput, MatSuffix } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatLabel } from '@angular/material/form-field';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UserService } from '../../services/user.service';
import { HowToService } from './services/how-to.service';
import { TutorialSaved } from './models/tutorial';
import { TagsListComponent } from './components/tags-list/tags-list.component';
import { TutorialListComponent } from './components/tutorial-list/tutorial-list.component';
import { NewTutorialComponent } from './components/new-tutorial/new-tutorial.component';
import { LatestTutorialsComponent } from './components/latest-tutorials/latest-tutorials.component';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-how-to',
  templateUrl: './how-to.component.html',
  styleUrls: ['./how-to.component.scss'],
  imports: [
    AsyncPipe,
    MatButton,
    MatFormField,
    MatLabel,
    MatInput,
    MatSuffix,
    ReactiveFormsModule,
    TagsListComponent,
    TutorialListComponent,
    LatestTutorialsComponent,
    MatIcon
  ],
  standalone: true
})
export class HowToComponent implements OnInit, OnDestroy {
  canCreateTutorials$ = of(false);
  selectedTag = '';
  filter = '';
  searchControl = new FormControl('', { nonNullable: true });

  private subscription = new Subscription();
  private destroyRef = inject(DestroyRef);

  constructor(
    private dialog: MatDialog,
    private tutorialsService: HowToService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.canCreateTutorials$ = this.userService
      .getUserInfo()
      .pipe(map(({ permissions }) => permissions.includes('Tutorials.Edit')));

    this.searchControl.valueChanges
      .pipe(
        tap(value => (this.filter = value)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  newTutorial() {
    this.subscription.add(
      this.dialog
        .open(NewTutorialComponent, {
          minWidth: '500px',
          height: '80vh',
          data: { editMode: false }
        })
        .afterClosed()
        .pipe(
          tap((resp: TutorialSaved) => {
            if (resp === 'Saved') {
              this.tutorialsService.refreshTutorialList();
            }
          })
        )
        .subscribe()
    );
  }

  clearSearch() {
    this.searchControl.setValue('');
  }
}
